// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"387":"d7698149","787":"a521a639"}[chunkId] + ".chunk.js";
};